import React, { FC, ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div
      className={`nc-SectionHero relative ${className}  lg:p-0 mb-20 lg:mb-36`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left lg:justify-between">
        <div className="flex-grow max-w-2xl">
          <img className="" src={rightImg} alt="" />
        </div>
        <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-[#121212] md:text-4xl xl:text-5xl dark:text-neutral-100">
            {heading}
          </h2>
          <span className="block !font-normal !text-md text-[#121212B2] dark:text-neutral-400">
            We pride ourselves on providing a luxury car and motorsports rental
            experience that is as seamless as it is customized. Each vehicle is
            crafted to give the impression of personal ownership, devoid of any
            branding or indicators of a rental, meanwhile our motorsports
            vehicles are not just visually appealing, but top-class in
            innovation and technology.
            <br />
            <br /> Every car and motorcraft is delivered in immaculate
            condition, having been thoroughly cleaned and professionally
            detailed, with attention to the smallest leather detail. If you are
            interested in our auto media and advertising for your luxury
            vehicle, give us a call!
          </span>

          {/* <ButtonPrimary onClick={() => navigate("/about")}>
            Read More
          </ButtonPrimary> */}
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
